import { Map } from "immutable";

import { composeSelectors } from "seneca-common/utils/selectors/compose-selectors";

import Assignee from "../../../../../models/Assignee";
import * as individualAssignee from "./individualAssignee";

type State = Map<string, Assignee>;

export function getAssignee(state: State, userId: string) {
  return state.get(userId);
}

export const {
  getStatus: getAssigneeStatus,
  getAggregatedStats: getAssigneeAggregatedStats,
  getSectionStats: getAssigneeSectionStats,
  getQuestionStats: getAssigneeQuestionStats
} = composeSelectors(getAssignee as any, individualAssignee);

export function getAssigneeIndividualSectionStats(
  state: State,
  userId: string,
  sectionId: string
) {
  const assignee = getAssignee(state, userId);

  return individualAssignee.getIndividualSectionStats(
    assignee as any,
    sectionId
  );
}

export function getAssigneeIndividualQuestionStats(
  state: State,
  userId: string,
  questionId: string
) {
  const assignee = getAssignee(state, userId);

  return individualAssignee.getIndividualQuestionStats(
    assignee as any,
    questionId
  );
}
